import axios from "axios";
import {setStorage} from '../config/Utils';


export const ForgotPassUser=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/forgot-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}

export const resetPassword=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/reset-password`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}